<template>
    <cadastro-simples-list
        endpoint="almox-motivo-recusa"
        rota-base="/admin/almox-motivo-recusa"
        titulo="ALMOXARIFADO — MOTIVOS DE CORTE"
        titulo-singular="Motivo">
    </cadastro-simples-list>
</template>
<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
